import Uploader from '../handler/Uploader';
import DragAndDrop from './DragAndDrop';
import FileManagerButton from './FileManagerButton';
import FileManagerModal from './FileManagerModal';
import UploadButton from './UploadButton';
import { commonComponents } from '../../common/components';

export const components = {
  ...commonComponents,
  DragAndDrop,
  FileManagerButton,
  FileManagerModal,
  Uploader,
  UploadButton,
};
